<template>
  <div class="menu" :class="{ collapse: menuData.collapse }">
    <div class="logo">
      <div><img src="/static/logo.png" style="width: 150px; height: auto; margin-top: -5px"></div>
      <h1 :class="{ hidden: menuData.collapse }"></h1>
    </div>
    <scrollbar>
      <el-menu
        ref="menu"
        :default-active="activeIndex"
        text-color="#fff"
        active-text-color="#fff"
        :collapse="menuData.collapse"
        :default-openeds="defaultOpeneds"
        :collapse-transition="false"
        @select="handleSelect"
      >
        <MenuItems v-for="menu in menuData.list" :key="menu.index" :menu="menu" :is-root-menu="true" />
      </el-menu>
    </scrollbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MenuItems from './MenuItems'
import Scrollbar from './Scrollbar'

export default {
  name: 'Menu',
  components: { Scrollbar, MenuItems },
  computed: {
    ...mapState(['menuData']),
    activeIndex () {
      let path = this.$route.path
      if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1)
      }
      const activeMenu = this.$route.meta && this.$route.meta.activeMenu ? this.$route.meta.activeMenu : path
      const menuConfig = this.__getMenuConfig(activeMenu, 'url', this.menuData.list)
      return menuConfig ? menuConfig.index : ''
    },
    defaultOpeneds () {
      return this.menuData.list.map(menu => menu.index)
    }
  },
  methods: {
    handleSelect (menuIndex) {
      const menuConfig = this.__getMenuConfig(menuIndex, 'index', this.menuData.list)
      if (!menuConfig) {
        return
      }
      if (menuConfig.url === this.$route.path) {
        return
      }
      if (menuConfig.url == null || menuConfig.url.trim().length === 0) {
        return
      }
      this.$router.push(menuConfig.url)
    },
    __getMenuConfig (value, key, menus) {
      for (const menu of menus) {
        if (menu[key] === value) {
          return menu
        }
        if (menu.children != null && menu.children.length > 0) {
          const menuConfig = this.__getMenuConfig(value, key, menu.children)
          if (menuConfig != null) {
            return menuConfig
          }
        }
      }
      return null
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/variable";
.menu {
  height: 100%;
  display: flex;
  flex-direction: column;
  .logo {
    height: 60px;
    flex-shrink: 0;
    line-height: 60px;
    overflow: hidden;
    display: flex;
    background: @primary-color - 12;
    padding: 0 16px;
    & > div {
      width: 32px;
      flex-shrink: 0;
      margin-right: 12px;
      img {
        width: 100%;
        flex-shrink: 0;
        vertical-align: middle;
        position: relative;
        top: -2px;
      }
    }
    h1 {
      font-size: 16px;
      font-weight: 500;
      transition: opacity ease .3s;
      overflow: hidden;
      &.hidden {
        opacity: 0;
      }
    }
  }
  .el-menu {
    border-right: 0;
    user-select: none;
    /deep/ .el-menu-item.is-active {
      background-color: @primary-color - 30;
    }
    /deep/ .el-submenu {
      .el-submenu__title {
        background-color: @primary-color;
      }
      &.is-active {
        .el-submenu__title {
          background-color: @primary-color - 20;
        }
        .el-menu .el-menu-item {
          background-color: @primary-color - 20;
          &.is-active {
            background-color: @primary-color - 40;
          }
        }
      }
      .el-submenu__title i {
        color: #f7f7f7;
      }
    }
    /deep/ .el-menu-item {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background-color: @primary-color;
      i {
        color: #f7f7f7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Menu.vue